import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RESULT_LIST, RESULT_APPROVE_REJECT, RESULT_GETONE, RESULT_ALLOW_EDIT } from "../../api/constApi";
import { resultListApi, resultGetoneApi, approveRejectResultpi, allowEditResultApi } from "../Services/resultService";

export const resultList = createAsyncThunk(RESULT_LIST, async (payload) => {
    const response = await resultListApi(payload);
    return response.data;
});

export const resultGetone = createAsyncThunk(RESULT_GETONE, async (payload) => {
    const response = await resultGetoneApi(payload);
    return response.data;
});

export const approveRejectResult = createAsyncThunk(RESULT_APPROVE_REJECT, async (payload) => {
    const response = await approveRejectResultpi(payload);
    return response.data;
});

export const allowEditResult = createAsyncThunk(RESULT_ALLOW_EDIT, async (payload) => {
    const response = await allowEditResultApi(payload);
    return response.data;
});

export const resultSlice = createSlice({
    name: "result",
    initialState: {
        result: null,
        // districtWop: null,
        token: null,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(resultList.fulfilled, (state, action) => {
            state.result = action?.payload;
        });
        builder.addCase(approveRejectResult.fulfilled, (state, action) => {
            state.result = action?.payload?.Data;
        });
    }
});

export default resultSlice.reducer;